import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-cutting-plan-po-add',
    templateUrl: './cutting-plan-po-add.component.html',
    styleUrls: ['./cutting-plan-po-add.component.css'],
})
export class CuttingPlanPoAddComponent implements OnInit {
    public params?: GetCuttingPlanPoAddParams;

    public get?: CuttingPlanPoAddGet;

    public grid?: GridOptions<CuttingPlanPoAddGridRow>;

    constructor(
        private datatask: DataTaskService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.getCuttingPlanPoAdd(this.params);
        }
    }

    public async readGrid() {
        if (!this.grid) {
            this.grid = new Grid<CuttingPlanPoAddGridRow>()
                .setRememberId('w_cuttingplanpoadd_grid')
                .setLoadDataFunction({ method: 3989, parameters: () => this.get })
                .addToolbarButton({ name: 'cuttingplanpoadd_add_selected', text: 'cuttingplanpoadd_add_selected', translate: true, cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r', func: () => this.addSelectedCuttingPlanPo(), disable_if_no_selected: true });
        } else {
            await this.grid.gridfunc?.read();
        }
    }

    private async addSelectedCuttingPlanPo() {
        const selectedRows = this.grid?.gridfunc?.getIsSelectedRows() ?? [];

        if (selectedRows.length === 0) return;

        let count = 0;
        const progressModal = this.modal.openProgressDialog({ rememberId: 'w_cuttingplanpoadd_progressmodal', value: count, max: selectedRows.length });

        for (let row of selectedRows) {
            const { errorcode, errormessage } = await this.addCuttingPlanPo(row);

            if ('' + errorcode !== '0') {
                progressModal.updateStatus('invalid');
                progressModal.updateInvalidText(errormessage);
                break;
            }

            count = count + 1;
            progressModal.updateValue(count);
        }

        if (count === selectedRows.length) {
            progressModal.updateStatus('finish');
        }

        this.navigator?.back();
    }

    /**
     * Retrieves the page get for cutting plan po add.
     *
     * @datatask 3990
     * @datataskName sp_ws_p2_w_cuttingplanpoadd_get
     * @param params cutting plan keyno.
     * @returns promise containing page get.
     */
    private async getCuttingPlanPoAdd(params: GetCuttingPlanPoAddParams): Promise<CuttingPlanPoAddGet> {
        return (await this.datatask.Post(3990, params))[0];
    }

    /**
     * Adds the given po keyno to the cutting plan.
     *
     * @datatask 3991
     * @datataskName sp_ws_p2_w_cuttingplanpoadd_add
     * @param params the cutting plan po to add.
     * @returns promise containing validation.
     */
    private async addCuttingPlanPo(params: CuttingPlanPoAddGridRow): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3991, params))[0];
    }

    private async init() {
        await this.loadGet();
        this.navigator?.setHeading?.(this.get?.webpage_heading ?? '');
        this.readGrid();
    }

    ngOnInit(): void {
        console.log(this.navigator);
        this.navigator?.setSize?.({ height: '95vh', width: '98vw' });
        this.params = this.navigator?.params as any;
        this.init();
    }
}

interface GetCuttingPlanPoAddParams {
    cuttingplan_keyno: string;
}

interface CuttingPlanPoAddGet {
    cuttingplan_keyno: string;
    prod_id: string;
    webpage_heading?: string;
    from_same_order: '1' | '0';
}

interface CuttingPlanPoAddGridRow {
    po_keyno: number;
    prod_id: string;
    prod_name: string;
    olm_keyno: number;
    orderline_keyno: number;
    order_internal_no: number;
    order_order_no: number;
    confirmed_date: Date;
    stat_cust_no: number;
    stat_cust_name: string;
    is_selected: boolean;
}
